"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.tooltips.preview': 'Podgląd konwersacji',
    'conversations.tooltips.delete': 'Usuń konwersację',
};
